import { ReactComponent as FlagIcon } from "./svg/es-flag.svg";
import "../flag-icon.scss";

export const ESFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
